import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import useSeo from "@/hooks/useSeo";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import LatestReviews from "./components/LatestReviews";
import TimelineShowcase from "./components/TimelineShowcase";
import Principles from "./components/Principles";
import FaqSection, { faqs } from "./components/FaqSection";
import Testimonials from "./components/Testimonials";
import CtaSection from "./components/CtaSection";

export default function Home() {
  useSeo({
    title: "黑料热点 · 热点事件来龙去脉与时间线梳理复盘",
    description:
      "黑料热点专注热点事件的时间线梳理与完整复盘：从事件起因、发酵节点、各方回应，到背后真相与深层原因逐层拆解，用多方视角还原来龙去脉，让你理性看懂每一个热点。",
    keywords: "黑料热点,黑料热点来龙去脉,黑料热点时间线梳理,黑料热点背后真相,热点事件复盘",
    canonicalPath: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "黑料热点",
        description: "热点事件来龙去脉、时间线梳理与多方视角复盘内容站。",
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "/topics?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "黑料热点",
        email: "contact@heiliao-hot.example",
        description: "以时间线与多方视角整理热点事件的复盘内容平台。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((item) => ({
          "@type": "Question",
          name: item.q,
          acceptedAnswer: { "@type": "Answer", text: item.a },
        })),
      },
    ],
  });

  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <CategorySection />
        <LatestReviews />
        <TimelineShowcase />
        <Principles />
        <FaqSection />
        <Testimonials />
        <CtaSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}